import React, {Component} from "react";
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import queryString from 'query-string';
import Helmet from "react-helmet";

//コンポーネント読み込み
import CommonLogin from './CommonLogin';
import PwdChange from './PwdChange';
import PwdReset from './PwdReset';
import Error from './Error';

class Parent extends Component {

  render() {
    let params = {};
    let snsAssociateParams = {};

    // クエリパラメータが存在した場合
    if(Object.keys(this.props.qs).length) {
    
      // 必要なもののみ取得しコンポーネントへ渡す
      let tempParams = {};
      if (this.props.qs.AUTHENTICATED) {
        tempParams = queryString.parse(this.props.qs.AUTHENTICATED.substring(this.props.qs.AUTHENTICATED.indexOf("?") + 1));
      } 
      else {
        tempParams = this.props.qs;
      }

      params = {
        SITE_ID: this.props.qs.SITE_ID,
        AUTH_TYPE: this.props.qs.AUTH_TYPE,
        AUTHENTICATED: this.props.qs.AUTHENTICATED, 
        MESSAGE_AUTH: this.props.qs.MESSAGE_AUTH,
        ERROR_MESSAGE: this.props.qs.ERROR_MESSAGE,
        DESIGN_TYPE: tempParams.design,   
        LANGUAGE_TYPE: tempParams.lang
      }

      // 画面デザイン
      if (params.DESIGN_TYPE) {
        sessionStorage.setItem("design", params.DESIGN_TYPE);
      } else {
        if (!sessionStorage.getItem("design")) {
          if(localStorage.getItem("design")){
            sessionStorage.setItem("design",localStorage.getItem("design"));
            localStorage.removeItem("design");
          }else{
            sessionStorage.setItem("design", process.env.REACT_APP_DESIGN_DEFAULT_VALUE);
          }
        }
      }
      
      // 画面表示言語
      let validLang = ['ja', 'en'];
      if (params.LANGUAGE_TYPE && validLang.includes(params.LANGUAGE_TYPE)) {
        sessionStorage.setItem("lang", params.LANGUAGE_TYPE);
      } else {
        if (!sessionStorage.getItem("lang")) {
          if(localStorage.getItem("lang")){
            sessionStorage.setItem("lang",localStorage.getItem("lang"));
            localStorage.removeItem("lang");
          }else{
            sessionStorage.setItem("lang", process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE);
          }
        }
      }

      // 画面表示言語により対応する言語ファイルを読み取り、セッションに保存する
      let messageJson = "";
      messageJson = require('../jsonFile/message_' + sessionStorage.getItem("lang") + '.json');
      sessionStorage.setItem("messageList", JSON.stringify(messageJson)); 
    }
    // クエリパラメータが存在しない場合
    else {
      // セッションストレージに画面デザインが存在しない場合
      if (!sessionStorage.getItem("design")) {
        // ローカルストレージに画面デザインが存在する場合
        if(localStorage.getItem("design")){
          sessionStorage.setItem("design",localStorage.getItem("design"));
          localStorage.removeItem("design");
        }else{
          sessionStorage.setItem("design", process.env.REACT_APP_DESIGN_DEFAULT_VALUE);
        }
      }

      // セッションストレージに画面表示言語が存在しない場合
      if (!sessionStorage.getItem("lang")) {
        let messageJson = "";
        // ローカルストレージに画面表示言語が存在する場合
        if(localStorage.getItem("lang")){
          sessionStorage.setItem("lang",localStorage.getItem("lang"));
          localStorage.removeItem("lang");
          messageJson = require('../jsonFile/message_' + sessionStorage.getItem("lang") + '.json');
        }else{
          sessionStorage.setItem("lang", process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE);
          messageJson = require('../jsonFile/message_' + process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE + '.json');
        }
        sessionStorage.setItem("messageList", JSON.stringify(messageJson));
      }
    }

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // ヘッダ・フッタエレメント(画像部)を取得
    const linkManualImgElement = document.getElementById("linkManualImg");
    const linkAnnouncementImgElement = document.getElementById("linkAnnouncementImg");
    const linkMaintenanceImgElement = document.getElementById("linkMaintenanceImg");
    const linkContactImgElement = document.getElementById("linkContactImg");
    const linkPrivacyImgElement = document.getElementById("linkPrivacyImg");

    // ヘッダ・フッタエレメント(文言部)を取得
    const linkManualElement = document.getElementById("linkManual");
    const linkAnnouncementElement = document.getElementById("linkAnnouncement");
    const linkMaintenanceElement = document.getElementById("linkMaintenance");
    const linkContactElement = document.getElementById("linkContact");
    const linkPrivacyElement = document.getElementById("linkPrivacy");

    // ヘッダ・フッタエレメントの内容(画像部・文言部)を更新
    if(linkManualImgElement) linkManualImgElement.alt = messageList.common.guideNewWindow;
    if(linkAnnouncementImgElement) linkAnnouncementImgElement.alt = messageList.common.guideNewWindow;
    if(linkMaintenanceImgElement) linkMaintenanceImgElement.alt = messageList.common.guideNewWindow;
    if(linkContactImgElement) linkContactImgElement.alt = messageList.common.guideNewWindow;
    if(linkPrivacyImgElement) linkPrivacyImgElement.alt = messageList.common.guideNewWindow;
    if(linkManualElement) linkManualElement.textContent = messageList.header.linkManual;
    if(linkAnnouncementElement) linkAnnouncementElement.textContent = messageList.header.linkAnnouncement;
    if(linkMaintenanceElement) linkMaintenanceElement.textContent = messageList.footer.linkMaintenance;
    if(linkContactElement) linkContactElement.textContent = messageList.footer.linkContact;      
    if(linkPrivacyElement) linkPrivacyElement.textContent = messageList.footer.linkPrivacy;

    return (
      <section className="section">
        <Helmet
          htmlAttributes={{
            lang: window.changeLang(sessionStorage.getItem("lang")),
          }} >  
        </Helmet>
        <Router>
          <Switch>
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/login`} render={ (props) => <CommonLogin params= {params} {...props}/> }/>
            {(process.env.REACT_APP_USE_PWD_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/pwd_change`} render={ (props) => <PwdChange params= {params} {...props}/> }/>
            )}
            {(process.env.REACT_APP_USE_PWD_RESET === "true") && (
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/pwd_reset`} render={ (props) => <PwdReset params= {params} {...props}/> }/>
            )}
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/error`} render={ (props) => <Error params= {params} {...props}/> }/> 
            <Route component={Error} />
          </Switch>
        </Router>
      </section>
    )
  }
}

export default Parent